document.addEventListener('DOMContentLoaded', () => {
  const targetProductTitles = {
    "en": [
      "EasyDens - Digital Density Meter for Beer | by Anton Paar",
      "EasyDens - Digital Density Meter | by Anton Paar",
      "SmartRef - Digital Refractometer | by Anton Paar",
      "EasyDens & SmartRef Combo | by Anton Paar",
      "EasyDens - Digital Density Meter for Wine | by Anton Paar",
      "EasyDens - Digital Density Meter for Spirits | by Anton Paar",
      "EasyDens - Digital Density Meter for Kombucha | by Anton Paar",
      "EasyDens - Digital Density Meter for Hard Seltzer | by Anton Paar",
      "Homebrewer's Kit | by Anton Paar",
      "Winemaker's Kit | by Anton Paar"
    ],
    "de": [
      "EasyDens - Digitales Dichtemessgerät für Bier | by Anton Paar",
      "EasyDens - Digitales Dichtemessgerät | by Anton Paar",
      "SmartRef – Digitales Refraktometer | by Anton Paar",
      "EasyDens & SmartRef Combo | by Anton Paar",
      "EasyDens - Digitales Dichtemessgerät für Wein | by Anton Paar",
      "EasyDens - Digitales Dichtemessgerät für Spirituosen | by Anton Paar",
      "EasyDens - Digitales Dichtemessgerät für Kombucha | by Anton Paar",
      "EasyDens - Digitales Dichtemessgerät für Hard Seltzer | by Anton Paar",
      "Heimbrauer-Set | by Anton Paar",
      "Winzer-Set | by Anton Paar"
    ],
    "fr": [
      "EasyDens - Densimètre Numérique pour la bière | by Anton Paar",
      "EasyDens - Densimètre Numérique | by Anton Paar",
      "SmartRef - Réfractomètre numérique | par Anton Paar",
      "EasyDens & SmartRef Combo | by Anton Paar",
      "EasyDens - Densimètre Numérique pour le vin | by Anton Paar",
      "EasyDens - Densimètre Numérique pour les spiritueux | by Anton Paar",
      "EasyDens - Densimètre Numérique pour le kombucha | by Anton Paar",
      "EasyDens - Densimètre Numérique pour le hard seltzer | by Anton Paar",
      "Kit de brasseur amateur | by Anton Paar",
      "Kit du vigneron | by Anton Paar"
    ],
    "it": [
      "EasyDens - Densimetro Digitale per la birra | by Anton Paar",
      "EasyDens - Densimetro Digitale | by Anton Paar",
      "SmartRef - Rifrattometro digitale | di Anton Paar",
      "EasyDens & SmartRef Combo | by Anton Paar",
      "EasyDens - Densimetro Digitale per il vino | by Anton Paar",
      "EasyDens - Densimetro Digitale per i distillati | by Anton Paar",
      "EasyDens - Densimetro Digitale per il kombucha | by Anton Paar",
      "EasyDens - Densimetro Digitale per l'hard seltzer | by Anton Paar",
      "Kit per homebrewer | by Anton Paar",
      "Kit per l'enologo | by Anton Paar"
    ],
    "es": [
      "EasyDens - Densímetro Digital para cerveza | by Anton Paar",
      "EasyDens - Densímetro Digital | by Anton Paar",
      "SmartRef - Refractómetro digital | de Anton Paar",
      "Combo EasyDens y SmartRef | by Anton Paar",
      "EasyDens - Densímetro Digital para vino | by Anton Paar",
      "EasyDens - Densímetro Digital para espirituosos | by Anton Paar",
      "EasyDens - Densímetro Digital para kombucha | by Anton Paar",
      "EasyDens - Densímetro Digital para hard seltzer | by Anton Paar",
      "Kit de cervecero casero | by Anton Paar",
      "Kit del enólogo | by Anton Paar"
    ]
  };

  const shippingTexts = {
    "en": "Shipping calculated at checkout",
    "de": "Versand wird beim Checkout berechnet",
    "fr": "Frais d'expédition calculés à l'étape de paiement",
    "it": "Spese di spedizione calcolate al check-out.",
    "es": "Los gastos de envío se calculan en la pantalla de pago"
  };

  const freeShippingTexts = {
    "en": '<a href="/policies/shipping-policy">Free Shipping*</a>',
    "de": '<a href="/de/policies/shipping-policy">Gratis Versand*</a>',
    "fr": '<a href="/fr/policies/shipping-policy">Livraison gratuite*</a>',
    "it": '<a href="/it/policies/shipping-policy">Spedizione gratuita*</a>',
    "es": '<a href="/es/policies/shipping-policy">Envío gratuito*</a>'
  };

  function detectLanguage() {
    let lang = document.documentElement.lang || "en";
    lang = lang.split('-')[0];
    if (!targetProductTitles[lang]) {
      lang = "en";
    }
    return lang;
  }

  function updateShippingText() {
    const lang = detectLanguage();
    const productsInLang = targetProductTitles[lang];
    let productTitleElement = document.querySelector('.product-featured__title.section__title a') ||
                              document.querySelector('.product-single__title');
    let productTitle = productTitleElement ? productTitleElement.innerText.trim() : "";
    if (productsInLang.includes(productTitle)) {
      const priceNotes = document.querySelectorAll('.price__note');
      if (priceNotes.length > 2 && priceNotes[2].innerText.includes(shippingTexts[lang])) {
        priceNotes[2].innerHTML = freeShippingTexts[lang];
      }
    }
  }

  updateShippingText();

  const observer = new MutationObserver(updateShippingText);
  observer.observe(document.body, { childList: true, subtree: true });
});
